import React, { useState } from "react";
import "../../../css/waterBottle.css";
// import { motion } from "framer-motion";
import { motion } from "framer-motion";



const WaterBottle = () => {
    const [waterLevel, setWaterLevel] = useState(0);
    const maxWaterLevel = 3000; // 3 litres max
    const step = 250; // Ajout de 250 ml par action

    const addWater = () => {
        setWaterLevel((prev) => Math.min(prev + step, maxWaterLevel));
    };

    const removeWater = () => {
        setWaterLevel((prev) => Math.max(prev - step, 0));
    };

    const waterPercentage = (waterLevel / maxWaterLevel) * 100;

    return (
        <div className="container text-center p-4">
            {/* <h2 className="mb-3">
                Today you took <span className="text-primary">{(waterLevel / 1000).toFixed(1)} ltr</span> of water
            </h2> */}

            {/* Bouteille avec effet graduation et bulle flottante */}
            <div className="bottle-container">
                <div className="bottle-horizontal">
                    <motion.div 
                        className="water" 
                        style={{ width: `${waterPercentage}%` }}
                        animate={{ width: `${waterPercentage}%` }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className="bubble">{(waterLevel / 1000).toFixed(1)}</div>
                    </motion.div>
                    <div className="graduation-container">
                        {[0, 25, 50, 75, 100].map((level) => (
                            <div key={level} className="graduation" style={{ left: `${level}%` }}>
                                {level}%
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Indicateurs */}
            <div className="d-flex justify-content-between px-4 text-muted small">
                <span>Poor</span>
                <span>Good</span>
                <span>Almost</span>
                <span>Perfect</span>
            </div>

            {/* Boutons */}
            {/* <div className="mt-4">
                <button className="btn btn-primary mx-2" onClick={addWater}>+ 250ml</button>
                <button className="btn btn-danger mx-2" onClick={removeWater}>- 250ml</button>
            </div> */}

            {/* Dernière mise à jour */}
            <div className="mt-4 p-3 bg-light rounded">
                <strong>Last Update</strong>
                <p className="mb-0">Water: {step} ml</p>
            </div>
        </div>
    );
};

export default WaterBottle;
